export enum SubmissionLocale {
  EN_US = 'en-US',
  EN_GB = 'en-GB'
}

export const DEFAULT_ENTRY_SUBMISSION_LOCALES: string[] = [SubmissionLocale.EN_US, SubmissionLocale.EN_GB]

export type LocaleSwitchHeaderProps = {
  selectedLocale: string
  setSelectedLocale: (locale: string) => void
  originalLocale: string
  translationAvailable: boolean
}
